import React, { useState, useEffect } from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const PurchasedProducts = () => {
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPurchases = async () => {
            const token = localStorage.getItem('token');

            try {
                const response = await fetch("https://api.fullagro.com:8888/purchases", {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error("Network response was not ok.");
                }

                const data = await response.json();
                setPurchases(data.purchases);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPurchases();
    }, []);

    return (
        <div className="purchases-container">
            <Typography variant="h4" className="purchases-title">Purchased products</Typography>
            {loading ? (
                <Typography variant="body1">Cargando productos comprados...</Typography>
            ) : error ? (
                <Typography variant="body1" color="error">Error: {error}</Typography>
            ) : purchases && purchases.length > 0 ? (
                <TableContainer className="table-purchases" component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Strain</TableCell>
                                <TableCell>Batch ID</TableCell>
                                <TableCell>Cycle</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>Purchased at</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {purchases.map((purchase) => (
                                <TableRow key={purchase.id}>
                                    <TableCell>{purchase.strain}</TableCell>
                                    <TableCell>{purchase.batchID}</TableCell>
                                    <TableCell>{purchase.cycle}</TableCell>
                                    <TableCell>{purchase.quantity}</TableCell>
                                    <TableCell>{new Date(purchase.created_at).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <Typography>No se encontraron compras.</Typography>
            )}
        </div>
    );
};

export default PurchasedProducts;